import { useState, type FormEvent } from 'react'
import { WAITLIST_COPY, type WaitlistLang } from '../lib/waitlist'
import type { WaitlistState } from '../hooks/useWaitlist'

// The waitlist form (040_waitlist.sql): an email, a button and the consent it
// asks for. Presentational: LoginPage wires it to useWaitlist, and the
// prerender (src/prerender.tsx) draws it idle for the static page.
export function WaitlistForm({ lang, state, onJoin }: {
  lang: WaitlistLang
  state: WaitlistState
  onJoin: (email: string) => void
}) {
  const t = WAITLIST_COPY[lang]
  const [email, setEmail] = useState('')
  const message = state === 'invalid' ? t.invalid : state === 'busy' ? t.busy : state === 'failed' ? t.failed : null

  function submit(e: FormEvent) {
    e.preventDefault()
    onJoin(email)
  }

  if (state === 'done') return <p role="status" className="ml-waitlist__done">{t.done}</p>
  return (
    <form className="ml-waitlist" onSubmit={submit} noValidate>
      <div className="ml-waitlist__row">
        <input className="ml-waitlist__input" type="email" inputMode="email" autoComplete="email"
          aria-label={t.label} placeholder={t.placeholder} value={email} maxLength={254}
          aria-invalid={state === 'invalid' || undefined} aria-describedby="ml-waitlist-consent"
          onChange={e => setEmail(e.target.value)} />
        <button type="submit" className="ml-waitlist__btn" data-track="waitlist-submit" disabled={state === 'sending'}>{t.join}</button>
      </div>
      {message && <p role="alert" className="ml-waitlist__error">{message}</p>}
      <p id="ml-waitlist-consent" className="ml-waitlist__consent">{t.consent}</p>
    </form>
  )
}
